<div class="ex-modal-header">
  <div class="ex-modal-title">{{ 'features.smart-search.modal-title' | translate }}</div>
  <ex-button icon="x-bold" type="secondary" variant="ghost" size="small" (click)="modal.dismiss()"></ex-button>
</div>
<div class="ex-modal-body">
  <video
    class="ex-modal-media"
    controls
    height="400"
    autoplay
    src="assets/videos/decouvrez-les-analyses-ia.mp4"
    poster="assets/images/feature-thumbnail-smart-search.svg"
  ></video>
</div>
